"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.InitFunction = exports.RouterComp = void 0;
// ----------- import Packs
var react_1 = __importDefault(require("react"));
var setRoutes_1 = require("./setRoutes");
// ----------- export Component
var RouterComp = function (props) {
    // ----------- set props
    var setHome = props.setHome, routes = props.routes, SetCurrSc = props.SetCurrSc, getData = props.getData;
    // ----------- set Data
    var initRoute = {};
    // ----------- set Hooks
    var _a = react_1["default"].useState(false), sttShow = _a[0], setShow = _a[1];
    var _b = react_1["default"].useState(initRoute), sttRoutesInfo = _b[0], setRoutesInfo = _b[1];
    // ----------- set Component
    var readRoutes = function () {
        var routesInfo = (0, setRoutes_1.setRoutes)(routes);
        setRoutesInfo(routesInfo);
        setShow(true);
    };
    // ----------- set Return
    return (react_1["default"].createElement(exports.InitFunction, { setFunction: readRoutes }, sttShow && react_1["default"].createElement(SetCurrSc, { info: { sttRoutesInfo: sttRoutesInfo, setHome: setHome, getData: getData } })));
};
exports.RouterComp = RouterComp;
var InitFunction = function (_a) {
    var children = _a.children, setFunction = _a.setFunction;
    // ----------- set Hooks
    var _b = react_1["default"].useState(false), sttCondShow = _b[0], setCondChildren = _b[1];
    // ----------- set Effects
    var fxInitData = function () {
        setFunction();
        setCondChildren(true);
    };
    react_1["default"].useEffect(fxInitData, []);
    // ----------- set Return
    return react_1["default"].createElement(react_1["default"].Fragment, null, sttCondShow && children);
};
exports.InitFunction = InitFunction;
